import { useQuery } from '@tanstack/react-query';

import api from 'api';
import useProjectRoute from 'hooks/useProjectRoute';

export const generateIntegrationRecordsQueryKey = (
  accountId: string,
  projectId: string,
) => [accountId, projectId, 'integrationRecords'];

const useIntegrationRecords = () => {
  const { accountId, projectId } = useProjectRoute();

  return useQuery(
    generateIntegrationRecordsQueryKey(accountId, projectId),
    () => api.getIntegrationRecords({ accountId, projectId }),
    {
      enabled: !!accountId && !!projectId,
      retry: false,
      refetchOnWindowFocus: false,
    },
  );
};

export default useIntegrationRecords;
